import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { localStorageSupported } from "../../../Helpers/localStorage";
import Modal from "../../General/Modal";

interface DisclaimerProps {}

const disclaimerText: JSX.Element = (
    <div>
        <p>
            This Installed Base internal initiative and this data user interface
            aims to deliver a solution to Metso Users for viewing and internally
            evaluating our customer installed base (“Purpose”).
        </p>

        <p>
            Metso is disclosing to You certain commercial, technical, financial
            and operational information and know-how relating to customer`s
            installed base including existing Metso and third party equipment on
            a customer site (“Confidential Information”) subject to You
            maintaining the confidentiality and restricting the use and further
            disclosure of such Confidential Information in accordance with the
            terms and conditions as set out below:
        </p>

        <p>
            You recognize the proprietary and confidential nature of the
            Confidential Information and you accordingly undertake to hold in
            strict confidence any Confidential Information disclosed to you in
            this data user interface, whether marked confidential or not, and
            you shall take all reasonable precautions to prevent the same in
            whole or in part from reaching third parties including Customers and
            Suppliers.
        </p>

        <p>
            You further more undertake to use the Confidential Information
            solely for the Purpose, and you shall make no other use thereof
            without the prior written consent of Metso.
        </p>

        <p>
            However, You shall be under no obligation of confidence and
            restricted use as to any information and knowledge in this data user
            interface in case such information is in public domain or has been
            lawfully disclosed to You by a third party including customers or
            suppliers having rightful possession thereof and no obligation of
            secrecy as to the said information exists.
        </p>

        <p>
            You shall limit access to Confidential Information to other Metso
            employees as required for the Purpose on a need-to-know basis and
            provided that such information is marked as confidential.
        </p>

        <p>
            You shall not make copies or reproductions of the Confidential
            Information except to the extent required for the Purpose and You
            shall at Metso’s request return or destroy all Confidential
            Information including all copies of any kind.
        </p>
    </div>
);

export default function Disclaimer(props: any) {
    const acceptedValue =
        localStorageSupported && localStorage.getItem("acceptIBTerms");
    const [accepted, setAccepted] = useState<boolean>(acceptedValue == "true");

    function acceptTerms(): any {
        if (localStorageSupported) {
            localStorage.setItem("acceptIBTerms", "true");
        }
        setAccepted(true);
    }

    if (accepted) {
        return <div />;
    }

    return (
        <Modal
            name="disclaimer"
            show={!accepted}
            shouldCloseOnOverlayClick={true}
        >
            <div className="Disclaimer">
                <h1 className="Disclaimer__header">Disclaimer</h1>

                <Scrollbars className="ScrollArea ScrollArea--Disclaimer">
                    <div className="Disclaimer__text">{disclaimerText}</div>
                </Scrollbars>

                <button
                    className="btn btn-primary Disclaimer__acceptButton"
                    onClick={(e) => acceptTerms()}
                >
                    I Agree
                </button>
            </div>
        </Modal>
    );
}
